var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Let's get started on your class's tech ed journey!")]),_c('br'),_c('curriculum-search')],1)}
var staticRenderFns = []

export { render, staticRenderFns }